import { Images } from "./images";

export interface RouteInfo {
  key: string;
  path?: string;
  pathRegex?: RegExp;
  isDetail?: boolean;
  title?: string;
  activeIcon?: string;
  inactiveIcon?: string;
}

export const RouteInfos: Record<string, RouteInfo> = {
  Profile: {
    key: "Profile",
    path: "/profile",
    pathRegex: new RegExp("\\/profile$"),
    title: "Profile",
    activeIcon: Images.SETTING_AC,
    inactiveIcon: Images.SETTING_DE,
  },
  Logout: {
    key: "Logout",
    title: "Sign Out",
    activeIcon: Images.LOG_OUT_DE,
    inactiveIcon: Images.LOG_OUT_DE,
  },
  Materials: {
    key: "Materials",
    path: "/materials",
    pathRegex: new RegExp("\\/materials$"),
    title: "Materials",
    activeIcon: Images.PALETTE_HOVER,
    inactiveIcon: Images.PALETTE,
  },
  Products: {
    key: "Products",
    path: "/products",
    pathRegex: new RegExp("\\/products$"),
    title: "Products",
    activeIcon: Images.PRODUCT_AC,
    inactiveIcon: Images.PRODUCT_DE,
  },
  HomeConfigurations: {
    key: "HomeConfigurations",
    path: "/homeConfigurations",
    pathRegex: new RegExp("\\/homeConfigurations$"),
    title: "Home Configuration",
    activeIcon: Images.SELECTION_AC,
    inactiveIcon: Images.SELECTION_DE,
  },
  Homes: {
    key: "Homes",
    path: "/homes",
    pathRegex: new RegExp("\\/homes$"),
    title: "Homes",
    activeIcon: Images.HOME_AC,
    inactiveIcon: Images.HOME_DE,
  },
  TenantUsers: {
    key: "TenantUsers",
    path: "/tenantUsers",
    pathRegex: new RegExp("\\/tenantUsers$"),
    title: "Users",
    activeIcon: Images.USER_AC,
    inactiveIcon: Images.USER_DE,
  },
  CompanyProfile: {
    key: "CompanyProfile",
    path: "/companyProfile",
    pathRegex: new RegExp("\\/companyProfile$"),
    title: "Company Profile",
    activeIcon: Images.COMPANY_AC,
    inactiveIcon: Images.COMPANY_DE,
  },
  Homebuyer: {
    key: "Homebuyer",
    path: "/homebuyer",
    pathRegex: new RegExp("\\/homebuyer$"),
    title: "Home Buyers",
    activeIcon: Images.HOMEBUYER_AC,
    inactiveIcon: Images.HOMEBUYER_DE,
  },
  ThemeConfig: {
    key: "ThemeConfig",
    path: "/themeConfig",
    pathRegex: new RegExp("\\/themeConfig$"),
    title: "Theme Config",
    activeIcon: Images.SETTING_AC,
    inactiveIcon: Images.SETTING_DE,
  },
};
